import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../lib/firebase";
import { useLocation, useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/admin";

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function onSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setError("");

    try {
      await signInWithEmailAndPassword(auth, email.trim(), password);
      navigate(from, { replace: true });
    } catch {
      setError("Login failed. Check your email/password.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="section stone">
      <div className="container" style={{ maxWidth: 520 }}>
        <header className="section-head">
          <h1>Admin Login</h1>
          <p className="muted">Sign in to view evaluation requests.</p>
        </header>

        <form className="form" onSubmit={onSubmit}>
          <label className="field">
            <input
              type="email"
              placeholder="Email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label className="field">
            <input
              type="password"
              placeholder="Password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>

          <button className="btn primary" disabled={busy}>
            {busy ? "Signing in..." : "Sign In"}
          </button>

          {error && <p className="micro" style={{ marginTop: 10 }}>{error}</p>}
        </form>
      </div>
    </section>
  );
}
